var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Product to components map - groups components by their product
 * More efficient than component-to-product as it avoids duplication
 */
var sdkMap = {
    'PDFViewerSDK': ['PDFViewer'],
    'DocumentSDK': ['PDFLibrary'],
    'DOCXEditorSDK': ['DOCXEditor'],
    'SpreadsheetEditorSDK': ['SpreadsheetEditor'],
    'SchedulerSDK': ['Scheduler'],
    'GanttSDK': ['Gantt', 'Kanban'],
    'DiagramSDK': ['Diagram'],
    'FileManagerSDK': ['FileManager'],
    'GridSDK': ['DataGrid', 'PivotTable', 'TreeGrid'],
    'RichTextEditorSDK': ['RichTextEditor', 'BlockEditor', 'RichTextEditorUI', 'HeadlessEditor'],
    'ChartSDK': ['Charts']
};
export var SDK_VERSION = '35.1.37';
/**
 * Gets the SDK name for a given component by looking it up in the sdkMap
 * @param {string} componentName - The name of the component
 * @returns {string} - The SDK name if found, defaults to 'Syncfusion.Telemetry'
 */
export function getSdkNameForComponent(componentName) {
    if (!componentName) {
        return 'ESUISDK';
    }
    // eslint-disable-next-line security/detect-object-injection
    for (var sdkName in sdkMap) {
        if (sdkMap.hasOwnProperty(sdkName)) {
            var components = sdkMap[sdkName];
            if (components.indexOf(componentName) !== -1) {
                return sdkName;
            }
        }
    }
    return 'ESUISDK';
}
/**
 * Initialize and configure telemetry for component tracking
 * @param {string} componentName - The name of the component to track
 * @returns {void}
 * @private
 */
export function initializeTelemetry(componentName) {
    if (typeof window !== 'undefined' && window.__karma__) {
        return;
    }
    var componentSdkName = getSdkNameForComponent(componentName);
    Telemetry.configure(function (options) {
        options.sdkVersion = SDK_VERSION;
    });
    Telemetry.trackComponent(componentName, componentSdkName);
}
/**
 * Initialize and configure telemetry for feature tracking
 * @param {string} featureName - The name of the feature to track
 * @param {string} componentName - The name of the component to track
 * @returns {void}
 * @private
 */
export function initializeTelemetryFeature(featureName, componentName) {
    if (typeof window !== 'undefined' && window.__karma__) {
        return;
    }
    var featureSdkName = getSdkNameForComponent(componentName);
    Telemetry.configure(function (options) {
        options.sdkVersion = SDK_VERSION;
    });
    Telemetry.trackFeature(featureName, componentName, featureSdkName);
}
// Provides static access to telemetry configuration and tracking.
var Telemetry = /** @class */ (function () {
    function Telemetry() {
    }
    Telemetry.disable = function () {
        this.isTelemetryEnable = false;
    };
    Telemetry.enable = function () {
        this.isTelemetryEnable = true;
    };
    Telemetry.configure = function (configure) {
        if (this.client) {
            return;
        }
        var options = new TelemetryOptions();
        configure(options);
        if (this.isTelemetryEnable) {
            this.client = new TelemetryClient(options);
        }
    };
    Telemetry.trackComponent = function (componentName, componentSdkName) {
        try {
            if (this.client && this.client.options.getEnvironment().toLowerCase().includes('development')) {
                this.client.trackComponent(componentName, componentSdkName);
            }
        }
        catch (_a) {
            /* ignore */
        }
    };
    Telemetry.trackFeature = function (featureName, componentName, featureSdkName) {
        try {
            if (this.client && this.client.options.getEnvironment().toLowerCase().includes('development')) {
                this.client.trackFeature(featureName, componentName, featureSdkName);
            }
        }
        catch (_a) {
            /* ignore */
        }
    };
    Telemetry.flushAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        if (!this.client) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.client.flushAsync()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Telemetry.shutdown = function () {
        try {
            if (this.client) {
                this.client.dispose();
            }
        }
        catch (_a) {
            /* ignore */
        }
        this.client = null;
    };
    Telemetry.client = null;
    Telemetry.isTelemetryEnable = false;
    return Telemetry;
}());
export { Telemetry };
// Configuration options that control telemetry collection and transport behavior.
var TelemetryOptions = /** @class */ (function () {
    // Initializes a new instance of the <see cref="TelemetryOptions"/> class.
    function TelemetryOptions() {
        this.enabled = true;
        this.connectionString = 'SW5zdHJ1bWVudGF0aW9uS2V5PWQ0ODg0NjhiLTEyNzYtNGJhNS04NGY0LTE3ZmZjNzMzNjQ1ZTtJbmdlc3Rpb25FbmRwb2ludD1odHRwczovL2Vhc3R1cy04LmluLmFwcGxpY2F0aW9uaW5zaWdodHMuYXp1cmUuY29tLzs=';
        this.endpoint = 'https://dc.services.visualstudio.com';
        this.sdkName = 'ESUISDK';
        this.sdkVersion = SDK_VERSION;
        this.framework = this.getFrameWork();
        this.frameworkVersion = this.getFrameWorkVersion();
        this.platform = 'EJ2';
        this.operatingSystem = this.getOperatingSystem();
        this.architecture = this.getArchitecture();
        this.environmentName = this.getEnvironment();
        this.maxQueueSize = 250;
        this.batchSize = 25;
        this.batchInterval = 6000;
        this.requestTimeout = 120000;
        this.maxRetries = 2;
        this.enableGzip = true;
        this.productionNoOpByDefault = true;
    }
    TelemetryOptions.prototype.getFrameWorkVersion = function () {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return '7';
        }
        if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__ ||
            document.querySelector('[data-reactroot], [data-reactid]')) {
            try {
                var hook = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
                if (hook && hook.renderers) {
                    var renderers = Array.from(hook.renderers.values());
                    if (renderers.length > 0 &&
                        renderers[0] &&
                        renderers[0].version) {
                        return renderers[0].version;
                    }
                }
            }
            catch (_a) {
            }
            return '19';
        }
        if (window.ng ||
            document.querySelector('[ng-version]') ||
            document.querySelector('[ng-app]')) {
            var ngVersionEl = document.querySelector('[ng-version]');
            if (ngVersionEl) {
                return ngVersionEl.getAttribute('ng-version');
            }
            return '22.1.1';
        }
        // Vue
        var vueRoot = document.querySelector('[data-v-app]') ||
            document.querySelector('#app');
        if (window.__VUE__ ||
            vueRoot && vueRoot.__vue__ ||
            vueRoot && vueRoot.__vue_app__) {
            if (vueRoot && vueRoot.__vue_app__ && vueRoot.__vue_app__.version) {
                return vueRoot.__vue_app__.version;
            }
            if (vueRoot && vueRoot.__vue__ && vueRoot.__vue__.$options && vueRoot.__vue__.$options._base && vueRoot.__vue__.$options._base.version) {
                return vueRoot.__vue__.$options._base.version;
            }
            if (vueRoot && vueRoot.__vue__ && vueRoot.__vue__.constructor && vueRoot.__vue__.constructor.version) {
                return vueRoot.__vue__.constructor.version;
            }
            return '3';
        }
        return '7';
    };
    TelemetryOptions.prototype.getFrameWork = function () {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return 'JavaScript';
        }
        if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__ ||
            document.querySelector('[data-reactroot], [data-reactid]')) {
            return 'React';
        }
        else if (window.ng ||
            document.querySelector('[ng-version]') ||
            document.querySelector('[ng-app]')) {
            return 'Angular';
        }
        else {
            var appEl = document.querySelector('#app');
            if (window.__VUE__ || document.querySelector('[data-v-app]') ||
                (appEl && appEl.__vue__) || (appEl && appEl.__vue_app__)) {
                return 'Vue';
            }
            // Detect TypeScript by checking for common TypeScript globals
            var ts = window.ts;
            if (ts && ts.version) {
                return 'TypeScript';
            }
            return 'JavaScript';
        }
    };
    TelemetryOptions.prototype.getArchitecture = function () {
        if (typeof navigator !== 'undefined') {
            var userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.includes('win')) {
                if (userAgent.includes('x64') || userAgent.includes('amd64')) {
                    return 'x64';
                }
                if (userAgent.includes('x86') || userAgent.includes('wow64')) {
                    return 'x86';
                }
                if (userAgent.includes('arm64')) {
                    return 'ARM64';
                }
                if (userAgent.includes('arm')) {
                    return 'ARM';
                }
            }
            if (userAgent.includes('mac')) {
                if (userAgent.includes('intel')) {
                    return 'x64';
                }
                if (userAgent.includes('ppc')) {
                    return 'PowerPC';
                }
                if (userAgent.includes('apple silicon') || userAgent.includes('arm64')) {
                    return 'ARM64';
                }
            }
            if (userAgent.includes('linux')) {
                if (userAgent.includes('x86_64') || userAgent.includes('amd64')) {
                    return 'x64';
                }
                if (userAgent.includes('i686') || userAgent.includes('i386')) {
                    return 'x86';
                }
                if (userAgent.includes('aarch64') || userAgent.includes('arm64')) {
                    return 'ARM64';
                }
                if (userAgent.includes('armv')) {
                    return 'ARM';
                }
            }
        }
        return 'x64';
    };
    TelemetryOptions.prototype.getOperatingSystem = function () {
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            var userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.includes('windows')) {
                return 'Windows';
            }
            else if (userAgent.includes('android')) {
                return 'Android';
            }
            else if (/iphone|ipad|ipod/.test(userAgent)) {
                return 'iOS';
            }
            else if (userAgent.includes('mac os x')) {
                return 'macOS';
            }
            else if (userAgent.includes('linux')) {
                return 'Linux';
            }
        }
        return 'Windows';
    };
    // Gets the runtime environment name.
    TelemetryOptions.prototype.getEnvironment = function () {
        if (typeof window !== 'undefined' && window.location) {
            // Check if running from a local file (file:// protocol)
            if (window.location.protocol === 'file:') {
                return 'Development';
            }
            if (window.location.hostname) {
                var hostname = window.location.hostname.toLowerCase();
                if (hostname === 'localhost' || hostname === '127.0.0.1') {
                    return 'Development';
                }
                if (/(^|\.)dev(\.|$)/.test(hostname)) {
                    return 'Development';
                }
                if (/(^|\.)staging(\.|$)|(^|\.)stage(\.|$)/.test(hostname)) {
                    return 'Staging';
                }
                if (/(^|\.)qa(\.|$)|(^|\.)test(\.|$)|(^|\.)uat(\.|$)/.test(hostname)) {
                    return 'Testing';
                }
            }
        }
        return 'Production';
    };
    return TelemetryOptions;
}());
export { TelemetryOptions };
// Generates a random identifier value.
export function randomUUID() {
    var hasCrypto = typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function';
    var hexDigits = '0123456789abcdef';
    var uuid = '';
    for (var i = 0; i < 36; i++) {
        if (i === 8 || i === 13 || i === 18 || i === 23) {
            uuid += '-';
        }
        else if (i === 14) {
            uuid += '4';
        }
        else {
            if (hasCrypto) {
                var randomByte = crypto.getRandomValues(new Uint8Array(1))[0];
                if (i === 19) {
                    uuid += hexDigits[(randomByte & 0x03) | 0x08];
                }
                else {
                    uuid += hexDigits[randomByte & 0x0f];
                }
            }
            else {
                uuid += i;
            }
        }
    }
    return uuid.replace(/-/g, '');
}
function parseConnectionString(connectionString) {
    if (!connectionString || connectionString.trim().length === 0) {
        return null;
    }
    try {
        var instrumentationKey = '';
        var ingestionEndpoint = '';
        connectionString = atob(connectionString);
        var parts = connectionString.split(';').map(function (p) { return p.trim(); }).filter(Boolean);
        for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
            var part = parts_1[_i];
            var idx = part.indexOf('=');
            if (idx <= 0) {
                continue;
            }
            var key = part.substring(0, idx).trim();
            var value = part.substring(idx + 1).trim();
            if (key === 'InstrumentationKey') {
                instrumentationKey = value.replace(/-/g, '');
            }
            else if (key === 'IngestionEndpoint') {
                ingestionEndpoint = value;
            }
        }
        if (!ingestionEndpoint && instrumentationKey) {
            ingestionEndpoint = 'https://dc.services.visualstudio.com';
        }
        return instrumentationKey ? { instrumentationKey: instrumentationKey, ingestionEndpoint: ingestionEndpoint } : null;
    }
    catch (_a) {
        return null;
    }
}
// Delays execution for the specified number of milliseconds.
function delay(ms) {
    return new Promise(function (res) { return setTimeout(res, ms); });
}
// Adds a property to the telemetry property bag if the value is not empty.
function addProp(target, key, value) {
    if (value === null || value === undefined) {
        return;
    }
    var s = String(value).trim();
    if (s.length > 0) {
        target[key] = s;
    }
}
function getSessionDedupKey(evt) {
    return evt.eventName + "|" + (evt.sdkName || '') + "|" + (evt.componentName || '') + "|" + (evt.featureName || '') + "|" + evt.sessionId;
}
function getDailyDedupKey(evt) {
    var y = evt.timestamp.getUTCFullYear();
    var month = evt.timestamp.getUTCMonth() + 1;
    var m = (month < 10 ? '0' : '') + month.toString();
    var day = evt.timestamp.getUTCDate();
    var d = (day < 10 ? '0' : '') + day.toString();
    return getSessionDedupKey(evt) + "|" + y + m + d;
}
// Combines multiple abort signals into a single signal.
function anySignal(signals) {
    var valid = signals.filter(Boolean);
    if (valid.length === 0) {
        return undefined;
    }
    var controller = new AbortController();
    for (var _i = 0, valid_1 = valid; _i < valid_1.length; _i++) {
        var s = valid_1[_i];
        if (s.aborted) {
            controller.abort();
            return controller.signal;
        }
        s.addEventListener('abort', function () { return controller.abort(); }, { once: true });
    }
    return controller.signal;
}
// Sends telemetry to Application Insights over HTTP.
var HttpTelemetrySender = /** @class */ (function () {
    // Initializes a new instance of the <see cref="HttpTelemetrySender"/> class.
    function HttpTelemetrySender(options) {
        this.options = options;
        var endpoint = options.endpoint || 'https://dc.services.visualstudio.com';
        var ikey = '';
        if (options && options.connectionString && options.connectionString.trim().length > 0) {
            var parse = parseConnectionString(options.connectionString);
            if (parse) {
                endpoint = parse.ingestionEndpoint || endpoint;
                ikey = parse.instrumentationKey || '';
            }
        }
        this.requestUrl = endpoint.replace(/\/$/, '') + "/v2/track";
        this.instrumentationKey = ikey;
    }
    // Sends the specified telemetry batch.
    HttpTelemetrySender.prototype.sendAsync = function (batch, signal) {
        return __awaiter(this, void 0, void 0, function () {
            var isBrowser, aiPayload, json, encoder, body, headers, controller, timeoutValue, timeout, combined, res, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!batch || !batch.events || batch.events.length === 0) {
                            return [2 /*return*/];
                        }
                        isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
                        if (!isBrowser) {
                            return [2 /*return*/];
                        }
                        aiPayload = this.createApplicationInsightsPayload(batch);
                        json = JSON.stringify(aiPayload);
                        encoder = new TextEncoder();
                        body = encoder.encode(json);
                        headers = {
                            'Content-Type': 'application/json'
                        };
                        controller = new AbortController();
                        timeoutValue = Math.max(1, this.options.requestTimeout || 10000);
                        timeout = setTimeout(function () { controller.abort(); }, timeoutValue);
                        combined = anySignal([controller.signal, signal]);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, fetch(this.requestUrl, {
                                method: 'POST',
                                headers: headers,
                                body: body,
                                signal: combined,
                                credentials: 'omit'
                            })];
                    case 2:
                        res = _b.sent();
                        if (!res.ok) {
                            throw new Error("HTTP " + res.status + " " + res.statusText);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _b.sent();
                        // Ignore network failures
                        return [2 /*return*/];
                    case 4:
                        clearTimeout(timeout);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // Creates the Application Insights payload for the specified batch.
    HttpTelemetrySender.prototype.createApplicationInsightsPayload = function (batch) {
        var items = [];
        for (var _i = 0, _a = batch.events; _i < _a.length; _i++) {
            var ev = _a[_i];
            items.push(this.createApplicationInsightsEvent(ev, batch));
        }
        return items;
    };
    HttpTelemetrySender.prototype.createApplicationInsightsEvent = function (ev, _batch) {
        var properties = {};
        addProp(properties, 'event.name', ev.eventName);
        addProp(properties, 'component.name', ev.componentName);
        addProp(properties, 'feature.name', ev.featureName);
        addProp(properties, 'session.id', ev.sessionId);
        addProp(properties, 'machine.name', ev.machineName || TelemetryClient.machineName);
        var opts = this.options;
        addProp(properties, 'sdk.name', ev.sdkName || opts.sdkName);
        addProp(properties, 'sdk.version', ev.sdkVersion || opts.sdkVersion);
        addProp(properties, 'framework', ev.framework || opts.framework);
        addProp(properties, 'framework.version', ev.frameworkVersion || opts.frameworkVersion);
        addProp(properties, 'platform_name', ev.platform || opts.platform);
        addProp(properties, 'os', opts.operatingSystem);
        addProp(properties, 'architecture', opts.architecture);
        var timeIso;
        var ts = ev.timestamp;
        if (ts instanceof Date) {
            timeIso = ts.toISOString();
        }
        else if (typeof ts === 'string') {
            timeIso = new Date(ts).toISOString();
        }
        else if (typeof ts === 'number') {
            timeIso = new Date(ts).toISOString();
        }
        else {
            timeIso = new Date().toISOString();
        }
        var iKey = this.instrumentationKey || '';
        return {
            name: 'Microsoft.ApplicationInsights.Event',
            time: timeIso,
            iKey: iKey,
            data: {
                baseType: 'EventData',
                baseData: {
                    name: String(ev.eventName || 'Event'),
                    properties: properties
                }
            }
        };
    };
    return HttpTelemetrySender;
}());
export { HttpTelemetrySender };
// Collects, deduplicates, batches, and forwards telemetry events.
var TelemetryClient = /** @class */ (function () {
    function TelemetryClient(options) {
        var _this = this;
        this.queue = [];
        this.sessionDedup = new Map();
        this.dailyDedup = new Map();
        this.timer = null;
        this.cleanupTimer = null;
        this.isFlushing = false;
        this.disposed = false;
        this.maxDedupSize = 500;
        this.dedupCleanupThreshold = 0.8;
        this.options = options;
        this.sender = new HttpTelemetrySender(options);
        // Generate session and machine IDs synchronously upfront
        TelemetryClient.sessionId = this.generateSessionId();
        TelemetryClient.machineName = this.generateMachineName();
        if (this.options.enabled) {
            this.timer = setInterval(function () {
                _this.flushAsync().catch(function () { });
            }, this.options.batchInterval);
            this.cleanupTimer = setInterval(function () {
                _this.cleanupStaleKeys();
            }, 5 * 60 * 1000);
        }
    }
    TelemetryClient.prototype.trackComponent = function (componentName, componentSdkName) {
        if (!this.shouldCollect()) {
            return;
        }
        var name = componentName;
        var evt = {
            eventName: 'component_initialized',
            timestamp: new Date(),
            sessionId: TelemetryClient.sessionId,
            machineName: TelemetryClient.machineName,
            sdkName: componentSdkName,
            sdkVersion: this.options.sdkVersion,
            componentName: name,
            featureName: 'Init',
            framework: this.options.framework,
            frameworkVersion: this.options.frameworkVersion,
            platform: this.options.platform,
            environment: this.options.environmentName,
            priority: 'Normal'
        };
        this.enqueue(evt);
    };
    TelemetryClient.prototype.trackFeature = function (featureName, componentName, featureSdkName) {
        if (!this.shouldCollect()) {
            return;
        }
        var name = featureName;
        var compname = componentName;
        var evt = {
            eventName: 'feature_used',
            timestamp: new Date(),
            sessionId: TelemetryClient.sessionId,
            machineName: TelemetryClient.machineName,
            sdkName: featureSdkName,
            sdkVersion: this.options.sdkVersion,
            featureName: name,
            componentName: compname,
            framework: this.options.framework,
            frameworkVersion: this.options.frameworkVersion,
            platform: this.options.platform,
            environment: this.options.environmentName,
            priority: 'Normal'
        };
        this.enqueue(evt);
    };
    TelemetryClient.prototype.flushAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var take, events, batch, attempt, max, err_1, backoff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isFlushing || this.disposed) {
                            return [2 /*return*/];
                        }
                        if (this.queue.length === 0) {
                            return [2 /*return*/];
                        }
                        this.isFlushing = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 11, 12]);
                        _a.label = 2;
                    case 2:
                        if (!(this.queue.length > 0)) return [3 /*break*/, 10];
                        take = Math.min(this.options.batchSize, this.queue.length);
                        events = this.queue.splice(0, take);
                        batch = {
                            schemaVersion: '1.0',
                            sdkVersion: this.options.sdkVersion,
                            sessionId: TelemetryClient.sessionId,
                            createdAt: new Date(),
                            events: events
                        };
                        attempt = 0;
                        max = Math.max(0, this.options.maxRetries);
                        _a.label = 3;
                    case 3:
                        if (!(attempt <= max)) return [3 /*break*/, 9];
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 8]);
                        return [4 /*yield*/, this.sender.sendAsync(batch)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 6:
                        err_1 = _a.sent();
                        if (attempt >= max) {
                            throw err_1;
                        }
                        backoff = Math.min(30000, Math.pow(2, attempt) * 500);
                        return [4 /*yield*/, delay(backoff)];
                    case 7:
                        _a.sent();
                        attempt++;
                        return [3 /*break*/, 8];
                    case 8: return [3 /*break*/, 3];
                    case 9: return [3 /*break*/, 2];
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        this.isFlushing = false;
                        return [7 /*endfinally*/];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    TelemetryClient.prototype.dispose = function () {
        if (this.disposed) {
            return;
        }
        this.disposed = true;
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        if (this.cleanupTimer) {
            clearInterval(this.cleanupTimer);
            this.cleanupTimer = null;
        }
        this.queue.length = 0;
    };
    TelemetryClient.prototype.shouldCollect = function () {
        if (!this.options.enabled || this.disposed) {
            return false;
        }
        var env = this.options.environmentName.toLowerCase() || '';
        if (env === 'ci') {
            return false;
        }
        if (env === 'testing') {
            return false;
        }
        if (this.options.productionNoOpByDefault && env === 'production') {
            return false;
        }
        return true;
    };
    TelemetryClient.prototype.hashId = function (value) {
        // FNV-1a 32-bit hash, expanded to 45 characters via base64 of derived bytes
        var hashBytes = new Uint8Array(34);
        var hash = 0x811c9dc5;
        var source = value && value.length > 0 ? value : 'unknown';
        for (var i = 0; i < hashBytes.length; i++) {
            var charCode = source.charCodeAt(i % source.length);
            hash ^= charCode + i;
            hash = Math.imul(hash, 16777619);
            hashBytes[i] = hash & 0xff; // eslint-disable-line
            hash >>>= 8;
        }
        var binary = '';
        for (var i = 0; i < hashBytes.length; i++) {
            binary += String.fromCharCode(hashBytes[i]); // eslint-disable-line
        }
        var encoded = btoa(binary).replace(/=+$/g, '');
        if (encoded.length >= 45) {
            return encoded.substring(0, 45);
        }
        return (encoded + encoded).substring(0, 45);
    };
    TelemetryClient.prototype.generateMachineName = function () {
        if (TelemetryClient.machineName) {
            return TelemetryClient.machineName;
        }
        var storageKey = 'telemetry_machine_id';
        try {
            var storedId = localStorage && localStorage.getItem(storageKey);
            if (storedId) {
                return storedId;
            }
        }
        catch (_a) {
            /* ignore */
        }
        // Step 2: Generate NEW unique ID (signature + random UUID + timestamp)
        var randomId = randomUUID();
        var machineId = this.hashId(randomId);
        try {
            localStorage.setItem(storageKey, machineId);
        }
        catch (_b) {
        }
        return machineId;
    };
    TelemetryClient.prototype.generateSessionId = function () {
        if (TelemetryClient.sessionId) {
            return TelemetryClient.sessionId;
        }
        var key = 'telemetry_session_id';
        try {
            var sessionId_1 = sessionStorage && sessionStorage.getItem(key);
            if (sessionId_1) {
                return sessionId_1;
            }
        }
        catch (_a) {
            // sessionStorage may throw in private mode / sandboxed iframes
        }
        var guid = randomUUID();
        var sessionId = this.hashId(guid);
        try {
            sessionStorage.setItem(key, sessionId);
        }
        catch (_b) {
            // sessionStorage may throw in private mode / sandboxed iframes
        }
        return sessionId;
    };
    TelemetryClient.prototype.enqueue = function (evt) {
        if (this.isDuplicate(evt)) {
            return;
        }
        if (this.queue.length >= this.options.maxQueueSize) {
            this.queue.shift();
        }
        this.queue.push(evt);
        if (this.queue.length >= this.options.batchSize) {
            this.flushAsync().catch(function () {
                /* ignore */
            });
        }
    };
    TelemetryClient.prototype.isDuplicate = function (evt) {
        var sessionKey = getSessionDedupKey(evt);
        var dailyKey = getDailyDedupKey(evt);
        var now = Date.now();
        if (!this.sessionDedup.has(sessionKey)) {
            this.sessionDedup.set(sessionKey, now);
            this.dailyDedup.set(dailyKey, now);
            this.enforceMaxSize(this.sessionDedup);
            this.enforceMaxSize(this.dailyDedup);
            return false;
        }
        if (this.dailyDedup.has(dailyKey)) {
            return true;
        }
        this.dailyDedup.set(dailyKey, now);
        this.enforceMaxSize(this.dailyDedup);
        return false;
    };
    TelemetryClient.prototype.enforceMaxSize = function (dedupMap) {
        var maxSize = this.maxDedupSize;
        var threshold = Math.floor(maxSize * this.dedupCleanupThreshold);
        if (dedupMap.size >= threshold) {
            var toRemove = Math.ceil(maxSize * 0.2);
            var entries = Array.from(dedupMap.entries());
            entries.sort(function (a, b) { return a[1] - b[1]; }); // Sort by timestamp
            for (var i = 0; i < toRemove && i < entries.length; i++) {
                dedupMap.delete(entries[i][0]);
            }
        }
    };
    TelemetryClient.prototype.cleanupStaleKeys = function () {
        var now = Date.now();
        var staleThreshold = 1 * 60 * 60 * 1000;
        try {
            var sessionEntries = Array.from(this.sessionDedup.entries());
            for (var _i = 0, sessionEntries_1 = sessionEntries; _i < sessionEntries_1.length; _i++) {
                var _a = sessionEntries_1[_i], key = _a[0], timestamp = _a[1];
                if (now - timestamp > staleThreshold) {
                    this.sessionDedup.delete(key);
                }
            }
            var dailyEntries = Array.from(this.dailyDedup.entries());
            for (var _b = 0, dailyEntries_1 = dailyEntries; _b < dailyEntries_1.length; _b++) {
                var _c = dailyEntries_1[_b], key = _c[0], timestamp = _c[1];
                if (now - timestamp > staleThreshold) {
                    this.dailyDedup.delete(key);
                }
            }
        }
        catch (_d) {
        }
    };
    TelemetryClient.sessionId = '';
    TelemetryClient.machineName = '';
    return TelemetryClient;
}());
export { TelemetryClient };
export default Telemetry;
